import type { FormEventHandler, ReactNode } from "react";
import { Sheet } from "@financeable-com-au/financeable-ui";

interface AuthCardProps {
  children: ReactNode;
  onSubmit?: FormEventHandler<HTMLFormElement>;
}

const AuthCard = ({ children, onSubmit }: AuthCardProps) => {
  return (
    <Sheet
      component="form"
      variant="outlined"
      borderRadius="lg"
      sx={{ width: "100%", maxWidth: 520, p: 10 }}
      onSubmit={(e: React.FormEvent) => {
        e.preventDefault();
        onSubmit?.(e as React.FormEvent<HTMLFormElement>);
      }}
    >
      {children}
    </Sheet>
  );
};

export { AuthCard };
